const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  pageRouter: state => state.user.pageRouter,
  indicators: state => state.dataCenter.indicators,
  template: state => state.dataCenter.template,
  checkIndicators: state => state.dataCenter.checkIndicators,
  templateInfo: state => state.dataCenter.templateInfo,
  isAdd: state => state.dataCenter.isAdd,
  leftIndex: state => state.dataCenter.leftIndex,
  tableData: state => state.dataCenter.tableData,
  targetTable: state => state.dataCenter.targetTable,
  urlName: state => state.routerUrl.urlName
}
export default getters
